import { useMutation } from '@tanstack/react-query';
import useToast from '../useToast';
import { TCustomAxiosError } from '@/services/api';
import { downgradePeerSupportToMemberPost } from '@/services/api/requests/peer-support';

const useDowngradePeerSupportToMember = (onSuccessCallback?: () => void) => {
  const toast = useToast();

  const { isPending, mutate } = useMutation({
    mutationFn: async ({ organizationId, userId }: { organizationId: string; userId: string }) => {
      const response = await downgradePeerSupportToMemberPost(organizationId, userId);

      return response;
    },
    onSuccess: () => {
      onSuccessCallback?.();

      toast({
        status: 'success',
        title: 'Success',
        description: 'Successfully downgraded Peer Support to Member!',
      });

      return;
    },
    onError: (error: TCustomAxiosError) => {
      toast(
        {
          status: 'error',
          title: 'Error',
          description: 'Error while downgrading Peer Support to Member',
        },
        error,
      );
    },
  });

  return { isPending, mutate };
};

export default useDowngradePeerSupportToMember;
